<template>
  <v-dialog v-model="show" @click:outside="close" width="500" @keydown.esc="close">
    <v-card :loading="status == 'loading'" class="modal-forgot">
      <v-toolbar :color="status == 'complete' ? '#159941' : '#159941'" flat>
        <v-toolbar-title style="color: white;"> Forgot password</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon>
          <v-icon @click="close" style="color: white;">fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-1">
        <div v-if="status != 'complete'">
          <p class="fonts-s12 fonts-400">Enter your email address, password will resend</p>

          <ValidationObserver ref="validator">
            <!-- Email -->
            <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
              <div class="my-0 module-input">
                <div class="fonts-s12 fonts-400 font-input-label">Correo electrónico</div>
                <v-text-field :error-messages="errors" :success="valid" v-model="user.email"
                  :append-icon="'fas fa-envelope'" :type="'email'" outlined dense autocomplete="off" readonly
                  onfocus="this.removeAttribute('readonly');" @change="setValidationMessage('')" />
              </div>
            </ValidationProvider>
          </ValidationObserver>

        </div>

        <v-alert color="green" dense text v-if="status == 'complete'">
          <v-row>
            <v-col cols="1">
              <v-icon color="green">fas fa-check-circle</v-icon>
            </v-col>

            <v-col>
              <p>{{ complete_message }}</p>
            </v-col>
          </v-row>
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-row style="padding: 0; margin: 0">
          <v-col class="text-center">
            <v-btn v-if="status != 'complete'" block rounded class="login-btn bg-btn-login btn-login-forgot"
              @click="submit" :loading="status === 'loading'" :disabled="!canSubmit">Resend
            </v-btn>

            <v-btn v-if="status == 'complete'" color="success" rounded elevation="0" @click="close">Ok
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";

export default {
  props: ["show", "hide"],
  created() { },
  computed: {
    ...mapState({
      status: (state) => state.Authenticate.forgot_status,
    }),
    canSubmit() {
      const email = this.user.email.trim();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }

  },
  data() {
    return {
      complete_message: "",
      user: {
        email: "",
      },
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    close() {
      this.user.email = "";
      this.$store.dispatch("Authenticate/reset_forgot_password");
      this.hide();
    },
    setValidationMessage(message) {
      this.validation_message = message;
    },
    async submit() {
      if (this.status == "complete") {
        close();
      } else {
        const self = this;
        const valid = await this.$refs.validator.validate();
        self.setValidationMessage("");
        if (valid) {
          self.$store
            .dispatch("Authenticate/forgot_password", self.user)
            .then(function (response) {
              self.complete_message = response.message;
            })
            .catch((response) => {

              for (let i in response.errors) {
                try {
                  console.log(
                    "self.$refs." +
                    i +
                    ".setErrors('" +
                    response.errors[i] +
                    "');"
                  );
                  eval(
                    "self.$refs." +
                    i +
                    ".setErrors('" +
                    response.errors[i] +
                    "');"
                  );
                } catch (error) {
                  //
                }
              }
            });
        }
      }
    },
  },
};
</script>
